'use strict';

const $ = window.jQuery;

export default class Popin {
    constructor() {
        $('.open-popin').on('click', function () {
            const popin = $(this).data('popin');

            $(`#popin-${popin}`).addClass('is-active');
        });

        $('.popin__close').on('click', function () {
            $('.popin').removeClass('is-active');
        });
    }
}
